import { FileNotFoundGitError } from '../errors/file-not-found.git-error';
import { UnprocessableJSONGitError } from '../errors/unprocessable-json.git-error';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { _FSReadFileActionFn } from './fs-read-file';

export interface FSReadJSONAction extends WorkerAction {
  type: FSAction.ReadJSON;
  params: { path: string; cwd?: string };
}

export async function FSReadJSONActionFn<T = unknown>(params: WorkerFnParams<FSReadJSONAction>): Promise<T | null> {
  const {
    util,
    params: { path },
  } = params;

  if (!util.itemExistsAt(path)) {
    throw new FileNotFoundGitError(path);
  }

  try {
    const fileContent = await _FSReadFileActionFn(params);
    return fileContent ? JSON.parse(fileContent) : null;
  } catch (err) {
    throw new UnprocessableJSONGitError(path);
  }
}
